import React, { useContext, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { MicrosoftLoginButton } from './MicrosoftLoginButton'
import { AuthContext } from 'contexts/AuthContext';
import { loginByMicrosoft } from '../../utils/api/authAPI';
import { SpinnerDiv } from '../../common/SpinnerDiv';
const _CLIENT_ID_ = process.env.REACT_APP_MICROSOFT_CLIENT_ID;

export const MicrosoftLogin = ({ setErr, email, setPublicEmail, redirectUrlPath, setAdditionalErr, toggle, setActiveView }) => {
    const navigate = useNavigate();
    const { id } = useParams();
    const { signIn, authorizeManagePublicReader } = useContext(AuthContext);
    const [submitting, setSubmitting] = useState(false);
    const redirectUrl = window.location.origin + redirectUrlPath;
    const urlParams = new URLSearchParams(window.location.search);
    const hash = urlParams.get('h');

    useEffect(() => {
        if (id && hash) {
            sessionStorage.setItem('readerInfo', JSON.stringify({ hash, id }));
        }
    }, []);

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');
        if (code) {
            const state_email = urlParams.get('state') || '';
            setPublicEmail(state_email);
            authorize(code, state_email);
        }
    }, [_CLIENT_ID_]);

    const authorize = async (code, state) => {
        try {
            setSubmitting(true);
            setErr(false);
            const res = await loginByMicrosoft(code, redirectUrl, state);
            if (res?.area === 'admin') {
                signIn(res.token);
                navigate('/account');
            } else if (res?.area === 'reader') {
                await authorizeManagePublicReader(res.token);
                await navigate(`/account/reader/${res.id}`);
            }
            toggle && toggle();
            setActiveView && setActiveView('alerts');
            setErr(false);
        } catch (err) {
            if ('LOGICAL_ERROR' === err.code) {
                setAdditionalErr(err.message);
            }
            setErr(true);
        } finally {
            setSubmitting(false);
        }
    };
    const _URL_ = `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?client_id=${_CLIENT_ID_}&response_type=code&redirect_uri=${encodeURIComponent(redirectUrl)}&response_mode=query&scope=User.Read&state=${email}`
    const clickHandler = (err, data) => {
        window.location.href = _URL_;
    };


    return (
        <>
            <MicrosoftLoginButton onClick={clickHandler}/>
            <SpinnerDiv show={submitting} />
        </>
    );
};
